var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyConsumedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 35,
    viewBox: "0 0 22 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54068 35C6.46307 35 6.3847 34.9854 6.30993 34.9541C6.05964 34.8496 5.92088 34.5925 5.97793 34.3389L8.95943 21.0574H0.575521C0.36019 21.0574 0.163358 20.9437 0.0644281 20.7615C-0.0345014 20.5794 -0.0185692 20.3611 0.105799 20.1939L14.9896 0.230538C15.1474 0.0183794 15.4398 -0.0575527 15.6901 0.0457235C15.9404 0.150219 16.0791 0.407303 16.0221 0.660968L13.0406 13.9424H21.4245C21.6398 13.9424 21.8366 14.0562 21.9356 14.2383C22.0345 14.4204 22.0186 14.6387 21.8942 14.8059L7.01103 34.7693C6.89977 34.918 6.72323 35 6.54054 35H6.54068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyConsumedIcon);
export default __webpack_public_path__ + "static/media/energyConsumedIcon.89cf09d14dd199bb5015347f61ceccc2.svg";
export { ForwardRef as ReactComponent };